export default "__VITE_ASSET__0d3b4f6c__"